<!--月数据表格-->
<template>
  <div>
    <el-table :data="dataList" height="795" border style="width: 100%;" v-loading="loading">
      <template slot="empty">
        <span class="noData">
          <img src="../../../assets/noData.png" alt="暂无数据">
          <span class="text">暂无数据</span>
        </span>
      </template>
      <el-table-column type="index" width="50" fixed>
      </el-table-column>
      <el-table-column prop="variablename" label="变量名" width="200" fixed>
      </el-table-column>
      <el-table-column prop="next" label="next" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.next" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1" label="value1" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2" label="value2" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value3" label="value3" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value3" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value4" label="value4" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value4" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value5" label="value5" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value5" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value6" label="value6" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value6" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value7" label="value7" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value7" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value8" label="value8" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value8" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value9" label="value9" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value9" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value10" label="value10" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value10" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value11" label="value11" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value11" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value12" label="value12" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value12" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value13" label="value13" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value13" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value14" label="value14" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value14" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value15" label="value15" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value15" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value16" label="value16" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value16" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value17" label="value17" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value17" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value18" label="value18" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value18" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value19" label="value19" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value19" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value20" label="value20" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value20" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value21" label="value21" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value21" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value22" label="value22" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value22" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value23" label="value23" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value23" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value24" label="value24" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value24" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value25" label="value25" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value25" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value26" label="value26" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value26" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value27" label="value27" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value27" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value28" label="value28" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value28" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value29" label="value29" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value29" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value30" label="value30" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value30" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value31" label="value31" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value31" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="320" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="singleDetermine(scope.row)" plain>确定修改</el-button>
          <el-button type="primary" size="mini" @click="average(scope.row)">首尾平均</el-button>
          <el-button type="primary" size="mini" @click="increment(scope.row)">自动增量</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default {
    components: {},
    props: {
      dataList: {
        type: Array,
        required: true,
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {}
    },
    created () {},
    mounted () {},
    destroyed () {},
    computed: {},
    watch: {},
    methods: {
      singleDetermine (data) {
        this.$emit("singleDetermine",data)
      },
      average (row) {
        //平均值
        let first=row['value1']
        let tail=row['next']
        if(tail!='-1.1111'&&!isempty(tail)&&first!='-1.1111'&&!isempty(first)) {
          let difference=((tail-first)/31).toFixed(3)
          for(let i=2;i<32;i++) {
            let onValue=Number(row['value'+(i-1)])
            if(onValue==-1.1111) {
              onValue=0
            }
            row['value'+i]=(onValue+Number(difference)).toFixed(3)
          }

          //将值找到再替换
        } else {
          this.$message.error("首值或者尾值不能为空")
        }
      },
      increment (row) {
        let first=row['value1']
        let two=row['value2']
        if(two!='-1.1111'&&!isempty(two)&&first!='-1.1111'&&!isempty(first)) {
          let difference=(two-first).toFixed(3)
          for(let i=3;i<32;i++) {
            let onValue=Number(row['value'+(i-1)])
            if(onValue==-1.1111) {
              onValue=0
            }
            row['value'+i]=(onValue+Number(difference)).toFixed(3)
          }
        } else {
          this.$message.error("第一值和第二值不能为空")
        }
      }
    }
  }
</script>

<style scoped>

</style>